const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 jam

type CachedUserCard = {
  photoDataUrl: string | null;
  sourceUrl: string;
  name: string;
  group_name: string;
};

const key = (userId: string | number) => `user_avatar_cache_${userId}`;

export const getUserAvatarCache = (userId: string | number): CachedUserCard | null => {
  try {
    const raw = localStorage.getItem(key(userId));
    if (!raw) return null;
    const { data, fetchedAt } = JSON.parse(raw);
    if (Date.now() - fetchedAt > CACHE_TTL) {
      localStorage.removeItem(key(userId));
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

export const setUserAvatarCache = (userId: string | number, data: CachedUserCard): void => {
  try {
    localStorage.setItem(key(userId), JSON.stringify({ data, fetchedAt: Date.now() }));
  } catch {
    // localStorage penuh atau tidak tersedia — abaikan, fallback ke network image
  }
};

export const fetchImageAsDataUrl = (url: string): Promise<string | null> => {
  return fetch(url)
    .then((res) => (res.ok ? res.blob() : Promise.reject(res)))
    .then(
      (blob) =>
        new Promise<string | null>((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve((reader.result as string) || null);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        }),
    )
    .catch(() => null);
};
